import type { BattleCommand, BattleResult, BattleRules, BattleState, CardId, PlayerId } from '../engine/types';
import type { PlayerStyleVector } from '../bot/learning/types';

export interface BattleSnapshot {
  tick: number;
  checksum: string;
}

export interface ReplayFile {
  formatVersion: 3;
  engineVersion: string;
  contentVersion: string;
  seed: number;
  rulesetId: string;
  rules: BattleRules;
  arenaId: string;
  decks: Readonly<Record<PlayerId, readonly CardId[]>>;
  botStrategy?: BotStrategyProvenance;
  match: ReplayMatchMetadata;
  commands: BattleCommand[];
  checkpoints: BattleSnapshot[];
  result: BattleResult | null;
}

export interface ReplayMatchMetadata {
  readonly mode: 'bot' | 'network';
  readonly resultTrust: 'local' | 'peer-confirmed' | 'server-verified';
  readonly networkMatchId: string | null;
  readonly localSide: PlayerId;
}

export interface BotStrategyProvenance {
  readonly schemaVersion: 1;
  readonly botId: string;
  readonly botVersion: string;
  readonly deckPolicyId: string;
  readonly deckPolicyVersion: string;
  readonly modelVersion: string | null;
  readonly modelHash: string;
  readonly confidence: number;
  readonly sourceMatches: number;
  readonly style: PlayerStyleVector;
  readonly selectedDeck: readonly CardId[];
  readonly deckScore: number;
  readonly rationale: readonly string[];
}

export function createReplay(
  seed: number,
  engineVersion: string,
  contentVersion: string,
  arenaId: string,
  rules: BattleRules,
  decks: Readonly<Record<PlayerId, readonly CardId[]>>,
  botStrategy?: BotStrategyProvenance,
  match: ReplayMatchMetadata = { mode: 'bot', resultTrust: 'local', networkMatchId: null, localSide: 'player' },
): ReplayFile {
  return { formatVersion: 3, engineVersion, contentVersion, seed, rulesetId: rules.id, rules: structuredClone(rules), arenaId, decks: structuredClone(decks), ...(botStrategy ? { botStrategy: structuredClone(botStrategy) } : {}), match: structuredClone(match), commands: [], checkpoints: [], result: null };
}

export function cloneState(state: BattleState): BattleState {
  return structuredClone(state);
}
